(function () {
  'use strict';

  const BUILD = '2026-06-29-v22';
  const LAYOUT_CLASS = 'nicha-tm-layout--stacked';
  const STYLE_ID = 'nicha-trackingmore-edd-styles';
  const SHADOW_STYLE_ID = 'nicha-trackingmore-edd-shadow-styles';
  const HOST_OVERRIDE_ID = 'nicha-tm-edd-frame-override';

  const SHADOW_CSS = `
    .tm-mainContainer,
    .tmsEddContainer {
      border-top: none !important;
      border-bottom: none !important;
      border: none !important;
      box-shadow: none !important;
    }
    .tmsEddContainer {
      border: none !important;
      border-radius: 0 !important;
      padding: 0 !important;
      margin: 0 !important;
    }
    .tm-eddOrderBefore {
      display: none !important;
    }
    .tm-eddTopAddress-content-text {
      font-weight: 400 !important;
    }
    .tm-eddTopAddress-content svg,
    .tm-eddTopAddress svg,
    .tm-eddTime svg {
      display: none !important;
    }
    .tmsEddContainer,
    .tm-eddTopAddress-content-text,
    .tm-eddTime,
    .tm-eddTime span {
      font-size: 1.15rem !important;
      line-height: 1.35 !important;
    }
  `;

  const isEnglish = () => {
    const locale = (window.Shopify?.locale || document.documentElement.lang || 'fr').toLowerCase();
    return locale === 'en' || locale.startsWith('en-');
  };

  const fixAddressText = (container) => {
    const addressEl = container.querySelector('.tm-eddTopAddress-content');
    if (!addressEl) return;

    addressEl.querySelectorAll('span').forEach((span) => {
      if (span.classList.contains('tm-eddTopAddress-content-text')) return;

      const text = span.textContent || '';
      if (!/\bLivrer\b/i.test(text) && !/\bDeliver\b/i.test(text)) return;

      const next = isEnglish()
        ? text.replace(/\bDeliver\b/gi, 'Delivery')
        : text.replace(/\bLivrer\b/gi, 'Livraison');

      if (next === text) return;
      span.textContent = next;
    });
  };

  const fixTimeText = (container) => {
    const timeEl = container.querySelector('.tm-eddTime');
    if (!timeEl) return;

    timeEl.querySelectorAll('span:not(.tm-boldFont)').forEach((span) => {
      const text = span.textContent || '';
      if (!/livraison|delivery|estimée|estimated/i.test(text)) return;

      let next = text
        .replace(/\bLivraison estimée\s*:\s*/gi, 'estimée : ')
        .replace(/\bLivraison\s+estimée\s*:\s*/gi, 'estimée : ')
        .replace(/\bEstimated delivery\s*:\s*/gi, 'estimated: ');

      if (/^\s*estimée\s*:?\s*$/i.test(next.trim())) next = 'estimée : ';
      if (next === text) return;
      span.textContent = next;
    });
  };

  const hideTrackingIcons = (container) => {
    container.querySelectorAll('.tm-eddTopAddress svg, .tm-eddTopAddress-content svg, .tm-eddTime svg').forEach((icon) => {
      icon.style.setProperty('display', 'none', 'important');
    });
  };

  const isMobile = () => window.matchMedia('(max-width: 989px)').matches;

  const clearLayoutInlineStyles = (container) => {
    const targets = [
      container,
      container.querySelector('.tm-eddTopAddress'),
      container.querySelector('.tm-eddTopAddress-content'),
      container.querySelector('.tm-eddTopAddress-content-text'),
      container.querySelector('.tm-eddTime'),
      ...container.querySelectorAll('.tm-eddTime span'),
    ].filter(Boolean);

    const props = [
      'display',
      'flex-wrap',
      'align-items',
      'gap',
      'line-height',
      'white-space',
      'width',
      'margin',
      'margin-top',
      'margin-bottom',
      'margin-left',
      'vertical-align',
      'flex',
      'flex-basis',
      'padding',
    ];

    targets.forEach((el) => props.forEach((prop) => el.style.removeProperty(prop)));
  };

  const injectShadowStyles = (shadow) => {
    if (!shadow || shadow === document || !isMobile()) return;
    let style = shadow.querySelector(`#${SHADOW_STYLE_ID}`);
    if (!style) {
      style = document.createElement('style');
      style.id = SHADOW_STYLE_ID;
      shadow.appendChild(style);
    }
    style.textContent = SHADOW_CSS;
  };

  const getEddMain = (host) => {
    if (!host) return null;
    if (host.tagName === 'TM-EDD-MAIN') return host;
    return host.querySelector('tm-edd-main');
  };

  const neutralizeAppStyleSheets = (eddMain) => {
    if (!eddMain || !isMobile()) return;

    eddMain.querySelectorAll(`style:not(#${HOST_OVERRIDE_ID})`).forEach((styleEl) => {
      const css = styleEl.textContent || '';
      if (!css.includes('tmsEddContainer')) return;

      const next = css
        .replace(/border\s*:\s*1px\s+solid\s+#c8c8c8/gi, 'border:none')
        .replace(/border-radius\s*:\s*8px/gi, 'border-radius:0')
        .replace(/padding\s*:\s*12px/gi, 'padding:0');

      if (next !== css) styleEl.textContent = next;
    });
  };

  const HOST_OVERRIDE_CSS = `
    @media (max-width: 989px) {
      .tmsEddContainer,
      .tm-mainContainer {
        border: none !important;
        border-top: none !important;
        border-bottom: none !important;
        border-width: 0 !important;
        border-color: transparent !important;
        border-radius: 0 !important;
        padding: 0 !important;
        padding-top: 0 !important;
        box-shadow: none !important;
      }
    }
  `;

  const ensureHostOverrideStyle = (eddMain) => {
    if (!eddMain || !isMobile()) return;

    let style = eddMain.querySelector(`#${HOST_OVERRIDE_ID}`);
    if (!style) {
      style = document.createElement('style');
      style.id = HOST_OVERRIDE_ID;
    }

    style.textContent = HOST_OVERRIDE_CSS;
    eddMain.appendChild(style);
  };

  const cleanupDesktopFrame = (eddMain) => {
    if (!eddMain || isMobile()) return;

    eddMain.querySelector(`#${HOST_OVERRIDE_ID}`)?.remove();
    eddMain.querySelectorAll('.tmsEddContainer').forEach((container) => {
      [
        'border-top',
        'border-bottom',
        'border',
        'border-width',
        'border-color',
        'border-radius',
        'padding',
        'padding-top',
      ].forEach((prop) => container.style.removeProperty(prop));
    });
  };

  const stripContainerFrame = (container) => {
    if (!container || !isMobile()) return;

    container.style.setProperty('border-top', 'none', 'important');
    container.style.setProperty('border-bottom', 'none', 'important');
    container.style.setProperty('border', 'none', 'important');
    container.style.setProperty('border-width', '0', 'important');
    container.style.setProperty('border-color', 'transparent', 'important');
    container.style.setProperty('border-radius', '0', 'important');
    container.style.setProperty('padding', '0', 'important');
    container.style.setProperty('padding-top', '0', 'important');
    container.style.setProperty('background', 'transparent', 'important');
    container.style.setProperty('background-image', 'none', 'important');
    container.style.setProperty('box-shadow', 'none', 'important');
  };

  const applyDeliveryLayout = (container) => {
    if (!container) return;
    if (!container.querySelector('.tm-eddTopAddress') || !container.querySelector('.tm-eddTime')) return;

    container.querySelector('.tm-eddOrderBefore')?.style.setProperty('display', 'none', 'important');
    clearLayoutInlineStyles(container);

    container.classList.remove('nicha-tm-layout--mobile', 'nicha-tm-layout--desktop', LAYOUT_CLASS);
    container.classList.add(LAYOUT_CLASS);
  };

  const collapseMobileGap = () => {
    if (!isMobile()) return;

    document
      .querySelectorAll('.shopify-app-block:has(.tmsEddContainer), .shopify-app-block:has(tm-edd-main)')
      .forEach((block) => {
        block.style.setProperty('margin-top', '0', 'important');
        block.style.setProperty('margin-bottom', '1.75rem', 'important');
        block.style.setProperty('padding-top', '0', 'important');
        block.style.setProperty('border-top', 'none', 'important');
      });

    const formWrap = document.querySelector('.product-form')?.closest('.product__info-container > div');
    if (formWrap) {
      formWrap.style.setProperty('margin-bottom', '0', 'important');
      formWrap.style.setProperty('padding-bottom', '0', 'important');
    }

    const buttons = document.querySelector('.product-form__buttons');
    if (buttons) buttons.style.setProperty('margin-bottom', '0', 'important');
  };

  const fixEddMainFrame = (eddMain) => {
    if (!eddMain) return;

    if (!isMobile()) {
      cleanupDesktopFrame(eddMain);
      return;
    }

    neutralizeAppStyleSheets(eddMain);
    ensureHostOverrideStyle(eddMain);
    eddMain.querySelectorAll('.tmsEddContainer').forEach(stripContainerFrame);
    collapseMobileGap();
  };

  const observeEddHost = (host) => {
    if (!host || host.dataset.nichaEddHostObserved === '1') return;
    host.dataset.nichaEddHostObserved = '1';

    let timer = null;
    new MutationObserver(() => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        fixEddMainFrame(getEddMain(host));
      }, 40);
    }).observe(host, { childList: true, subtree: true });
  };

  const injectTrackingFrameStyles = () => {
    let style = document.getElementById(STYLE_ID);
    if (!style) {
      style = document.createElement('style');
      style.id = STYLE_ID;
      document.head.appendChild(style);
    }
    if (style.dataset.build === BUILD) return;
    style.dataset.build = BUILD;

    style.textContent = `
      .tmsEddContainer.${LAYOUT_CLASS} {
        display: block !important;
        line-height: 1.35 !important;
        border: none !important;
        padding: 0 !important;
        margin: 0 !important;
      }
      .tmsEddContainer.${LAYOUT_CLASS} .tm-eddTopAddress,
      .tmsEddContainer.${LAYOUT_CLASS} .tm-eddTopAddress-content,
      .tmsEddContainer.${LAYOUT_CLASS} .tm-eddTopAddress-content-text,
      .tmsEddContainer.${LAYOUT_CLASS} .tm-eddTime,
      .tmsEddContainer.${LAYOUT_CLASS} .tm-eddTime span:not(.tm-boldFont) {
        display: inline !important;
        width: auto !important;
        margin: 0 !important;
      }
      .tmsEddContainer.${LAYOUT_CLASS} .tm-eddTopAddress-content-text {
        cursor: pointer !important;
      }
      .tmsEddContainer.${LAYOUT_CLASS} .tm-eddTime .tm-boldFont {
        display: block !important;
        margin: 0.1rem 0 0 !important;
      }
      @media (max-width: 989px) {
        div.tmsEddContainer[style],
        .tmsEddContainer {
          border-top: none !important;
          border-bottom: none !important;
          border: none !important;
          border-width: 0 !important;
          border-color: transparent !important;
          padding-top: 0 !important;
        }
        .product__info-wrapper .shopify-app-block:has(.tmsEddContainer),
        .product__info-wrapper .shopify-app-block:has(tm-edd-main) {
          margin-bottom: 1.75rem !important;
        }
      }
    `;
  };

  const customizeContainer = (container) => {
    if (!container) return;

    if (isMobile()) stripContainerFrame(container);

    const orderBefore = container.querySelector('.tm-eddOrderBefore');
    if (orderBefore) orderBefore.style.setProperty('display', 'none', 'important');

    hideTrackingIcons(container);
    fixAddressText(container);
    fixTimeText(container);
    applyDeliveryLayout(container);

    container.querySelectorAll('span').forEach((span) => {
      const plain = (span.textContent || '').trim();
      if (/^commander avant\s*:?$/i.test(plain) || /^order before\s*:?$/i.test(plain)) {
        span.style.setProperty('display', 'none', 'important');
      }
    });

    container.dataset.nichaTrackingmoreCustomized = 'true';
  };

  const shouldRun = () =>
    document.body.classList.contains('template-product') ||
    document.body.classList.contains('nicha-product-page') ||
    !!document.querySelector('.product__info-container, .product__info-wrapper') ||
    !!document.querySelector('tm-edd-main, tm-edd-main-container, .tmsEddContainer') ||
    /\/products\//.test(window.location.pathname || '');

  const getProductRoot = () =>
    document.querySelector('.product__info-wrapper, .product__info-container, .product');

  const scan = () => {
    if (!shouldRun()) return;

    document.querySelectorAll('tm-edd-main-container, tm-edd-main').forEach((host) => {
      observeEddHost(host);
      fixEddMainFrame(getEddMain(host));

      const shadow = host.shadowRoot;
      if (shadow) {
        if (isMobile()) injectShadowStyles(shadow);
        shadow.querySelectorAll('.tmsEddContainer').forEach(customizeContainer);
      }
      host.querySelectorAll('.tmsEddContainer').forEach(customizeContainer);
    });

    document.querySelectorAll('.tmsEddContainer').forEach((container) => {
      fixEddMainFrame(getEddMain(container.closest('tm-edd-main-container, tm-edd-main')));
      const root = container.getRootNode();
      if (root && root !== document && isMobile()) injectShadowStyles(root);
      customizeContainer(container);
    });
  };

  const boot = () => {
    if (!shouldRun()) return;

    console.info('[Nicha] nicha-trackingmore-edd.js actif —', BUILD);
    injectTrackingFrameStyles();
    scan();
    [200, 600, 1200, 2500, 5000, 8000, 12000, 18000].forEach((delay) => setTimeout(scan, delay));

    let resizeTimer = null;
    window.addEventListener(
      'resize',
      () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          document.querySelectorAll('.tmsEddContainer').forEach(applyDeliveryLayout);
        }, 120);
      },
      { passive: true }
    );

    if (document.body.dataset.nichaTrackingmoreObserver === 'true') return;
    document.body.dataset.nichaTrackingmoreObserver = 'true';

    const root = getProductRoot();
    if (!root) return;

    let timer = null;
    new MutationObserver(() => {
      clearTimeout(timer);
      timer = setTimeout(scan, 80);
    }).observe(root, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', () => setTimeout(scan, 100));

  window.NichaTrackingmoreEdd = { refresh: scan, build: BUILD };
})();
